// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cd62ab1f","453":"1833b684","553":"bb940427","977":"a58e95c2"}[chunkId] + ".chunk.js";
};